// app/hash-scroll-handler.tsx
'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export default function HashScrollHandler() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const hash = window.location.hash.substring(1);
    if (!hash) return;

    const handleScroll = () => {
      const eleId = "_" + hash;
      const element = document.getElementById(eleId);
      if (element) {
        const navbar = document.querySelector('#navbar');
        const navbarHeight = (navbar as HTMLElement)?.offsetHeight || 72;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - navbarHeight - 24;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'auto',
        });
        return true;
      }
      return false;
    };

    // 立即尝试滚动
    if (handleScroll()) return;

    // 如果元素不存在，设置观察器等待加载
    const observer = new MutationObserver(() => {
      if (handleScroll()) observer.disconnect();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [pathname, searchParams]); // 在路由变化时重新执行

  return null;
}
